import { Box, Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import SectionHeader from "./SectionHeader";

export default function BreadCrumbs({
  currentPage,
  type = 4,
  preHeading = "Rate",
}) {
  var breadcrumbs = [
    {
      name: "チケットを選ぶ",
      link: "/support/menu",
    },
    {
      name: "日時/相談員を選ぶ",
      link: "/support/staff",
    },
    {
      name: "お支払い",
      link: "/buy",
    },
  ];
  if (type == 2) {
    breadcrumbs = [
      {
        name: "お支払い",
        link: "/buy",
      },
    ];
  }
  const getCurrentBreadcrumbIndex = () => {
    return breadcrumbs.findIndex(
      (breadcrumb) => breadcrumb.name === currentPage
    );
  };

  return (
    <Box className="breadcrumbs-section">
      <SectionHeader currentPage={currentPage} preHeading={preHeading} />
      <Container className="container">
        <Grid
          container
          alignItems="center"
          className="breadcrumbs-wrapper"
          justifyContent="center"
        >
          {breadcrumbs.map((breadcrumb, index) => {
            const isActive = breadcrumb.name === currentPage;
            const isClickable = getCurrentBreadcrumbIndex() >= index;
            return (
              <Grid key={index} item md={3} sm={3} xs={3}>
                <div className={isActive ? "breadcrumb active" : "breadcrumb"}>
                  <span>
                    STEP <span>0{index + 1}</span>
                  </span>
                </div>
                <p
                  className={
                    isActive ? "breadcrumb-bottom active" : "breadcrumb-bottom"
                  }
                >
                  {breadcrumb.name}
                </p>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}
